// extracted by mini-css-extract-plugin
export default {"portlet":"Portlet__portlet--1Al"};